import { c as _c } from "react/compiler-runtime";
// biome-ignore-all lint/plugin/no-untranslated-copy: card network names are brands, not copy
import { IcoAmex24, IcoCreditcard24, IcoDankort24, IcoDiners24, IcoDiscover24, IcoForbrugsforeningen24, IcoJcb24, IcoMaestro24, IcoMastercard24, IcoUnionpay24, IcoVisa24, IcoVisaelectron24 } from '@onefootprint/icons';
import type { ReactNode } from 'react';
type CardIconProps = {
  brand?: string;
};
const CardIcon = t0 => {
  const $ = _c(2);
  const {
    brand
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      amex: <IcoAmex24 color="primary" aria-label="amex" />,
      dinersclub: <IcoDiners24 color="primary" aria-label="dinersclub" />,
      discover: <IcoDiscover24 color="primary" aria-label="discover" />,
      jcb: <IcoJcb24 color="primary" aria-label="jcb" />,
      maestro: <IcoMaestro24 color="primary" aria-label="maestro" />,
      mastercard: <IcoMastercard24 color="primary" aria-label="mastercard" />,
      unionpay: <IcoUnionpay24 color="primary" aria-label="unionpay" />,
      visa: <IcoVisa24 color="primary" aria-label="visa" />,
      visaelectron: <IcoVisaelectron24 color="primary" aria-label="visaelectron" />,
      forbrugsforeningen: <IcoForbrugsforeningen24 color="primary" aria-label="forbrugsforeningen" />,
      dankort: <IcoDankort24 color="primary" aria-label="dankort" />
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const brandIcons = t1;
  if (!brand || !brandIcons[brand]) {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <IcoCreditcard24 color="primary" />;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  return brandIcons[brand];
};
export default CardIcon;